import React from 'react';
import { useTranslation } from 'react-i18next';
import * as z from 'zod/v3';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

export const getSocialSecurityNumberRegex = () => /^(?:\d{9}|\d{4})$/;

const useRequalifyForm = () => {
  const { t } = useTranslation();

  const schema = React.useMemo(() => {
    return z.object({
      socialSecurityNumber: z
        .string()
        .min(1, { message: t('common.requiredFieldSSN') })
        .refine(
          (val) => {
            const regex = getSocialSecurityNumberRegex();
            return regex.test(val);
          },
          { message: t('fortiva.formlabel.invalidFormatSSN') }
        ),
    });
  }, [t]);

  const form = useForm({
    resolver: zodResolver(schema),
    mode: 'onChange',
    defaultValues: {
      socialSecurityNumber: '',
    },
  });

  return form;
};

export default useRequalifyForm;
